import {
  BankEligibility,
  BankEligibilityDocumentState,
  BankEligibilityDocumentType,
  BankEligibilityStatus,
  BankEligibilityStep,
} from './../../types'

export const MOCK_BANK_ELIGIBILITY: BankEligibility = {
  status: BankEligibilityStatus.ELIGIBLE,
  currentStepDetails: {
    step: BankEligibilityStep.OWNERS_ADDRESS_DETAILS_EU,
    state: BankEligibilityDocumentState.COMPLETED,
    data: {
      businessId: '0cd5e950-ae63-42a9-8a07-215447f78486',
      beneficialOwners: [
        {
          id: 'd3c9b329-82f8-4002-a4cf-12136cf11911',
          firstName: 'Decoupling',
          lastName: 'Bug',
          secondLastName: 'Fix',
          email: 'decoupling@bug-fix.com',
          address: {
            street: 'Ámsterdam 14',
            city: 'Ciudad de México',
            postcode: '06100',
            state: 'CDMX',
            countryCode: 'MEX',
          },
          document: {
            documentType: BankEligibilityDocumentType.PROOF_OF_ADDRESS,
            fileName:
              '23CA9EB9BFED604F53B42A86CA04FABF-5942706026115611993.jpg',
            displayableName: '5942706026115611993.jpg',
          },
        },
      ],
    },
  },
}
